module.exports = __webpack_public_path__ + "img/pic-star-tilt.b292ee6.svg";